import React from 'react';
import PropTypes from 'prop-types';

const AccordionItem = (props) => {
  // eslint-disable-next-line react/prop-types
  return <li className={props.className}>{props.children}</li>;
};

AccordionItem.propTypes = {
  /** Pass children elements to this element */
  children: PropTypes.node,
};

AccordionItem.defaultProps = {
  children: undefined,
};

export default AccordionItem;
